window.getPopoverOptions = (popoverComponent) => {
    const obj = $(popoverComponent);

    return {
        template:  obj.children('.template').html(),
        content:   obj.children('.content').html(),
        html:      true,
        sanitize:  false,
        trigger:   'manual',
        placement: obj.data('placement'),
    };
};

$(() => {
    // Dismiss/hide click-triggered popover when you click outside one (ie. the mouseup event bubbles up to the document
    $(document).on('mouseup', () => $('.popover.click-triggered:visible').popover('hide'));

    $('[data-toggle="popover"]').each(function (index, popoverComponent) {
        const obj = $(popoverComponent);
        const trigger = obj.data('trigger');

        if ('custom' === trigger) {
            return;
        }

        const popover = $(obj.data('target')).popover(getPopoverOptions(popoverComponent));

        if ('click' === trigger) {
            popover.on('mouseup', (evt) => {
                // Stop bubbling up so the document event handler doesn't end up hiding the popover we're trying to show in the first place
                evt.stopPropagation();
                evt.preventDefault();

                // As a result we need to make sure we hide all other click-triggered popovers explicitly
                $('.popover').popover('hide');

                // Show our popover and make sure clicking anything inside it won't bubble up either
                $(this).popover('show');

                $('.popover.click-triggered:visible *').on('mouseup', (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                });

                $('.popover.click-triggered:visible .dismiss').on('mouseup', (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    $(this).popover('hide');
                });
            });
        } else if ('hover' === trigger) {
            popover
                .on('mouseenter', function () {
                    const obj = $(this);
                    obj.popover('show');
                    $('.popover').on('mouseleave', function () {
                        obj.popover('hide');
                    });
                })
                .on('mouseleave', function () {
                    const obj = $(this);
                    setTimeout(function () {
                        if (!$('.popover:hover').length) {
                            obj.popover('hide');
                        }
                    }, 250);
                });
        }
    });
});
